import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import type { Meta } from "@/types";

let cache: Meta | null = null;

export function useMeta() {
  const [meta, setMeta] = useState<Meta | null>(cache);
  useEffect(() => {
    if (!cache) {
      api.get("/meta").then((r) => { cache = r.data; setMeta(r.data); });
    }
  }, []);
  return meta;
}
